import React from 'react'
import PropTypes from 'prop-types'

import classNames from 'classnames'

import styles from './Header.module.scss'
import LoginHeader from './LoginHeader'

const HeaderBar = (props) => {
    const {
        linkColor,
        contrastColor,
        memberType,
        textColor,
        isLoggedIn,
        userInitials,
        userEmail,
        onLoginButtonClick = () => {},
        hideLogin,
        useDefault,
        welcomeBack,
    } = props
    return (
        <div
            className={classNames(styles.header)}
            style={{ backgroundColor: linkColor }}
        >
            <LoginHeader
                linkColor={linkColor}
                contrastColor={contrastColor}
                memberType={memberType}
                textColor={textColor}
                userInitials={userInitials}
                isLoggedIn={isLoggedIn}
                userEmail={userEmail}
                onLoginButtonClick={onLoginButtonClick}
                hideLogin={hideLogin}
                useDefault={useDefault}
                welcomeBack={welcomeBack}
            />
        </div>
    )
}

HeaderBar.defaultProps = {
    linkColor: '',
    contrastColor: '',
    memberType: '',
    textColor: '',
    userInitials: '',
    userEmail: '',
    isLoggedIn: false,
    onLoginButtonClick: () => {},
    hideLogin: false,
    useDefault: false,
    welcomeBack: false,
}

HeaderBar.propTypes = {
    linkColor: PropTypes.string,
    contrastColor: PropTypes.string,
    memberType: PropTypes.string,
    textColor: PropTypes.string,
    userInitials: PropTypes.string,
    userEmail: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    onLoginButtonClick: PropTypes.func,
    hideLogin: PropTypes.bool,
    useDefault: PropTypes.any,
    welcomeBack: PropTypes.bool,
}

export default React.memo(HeaderBar)
